"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationErrorMessage = void 0;
var React = require("react");
var translation_1 = require("@caddigital/sok-ui/lib/utils/translation");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var react_redux_1 = require("react-redux");
var selectors_1 = require("../selectors");
var dispatchers_1 = require("../dispatchers");
var ValidationErrorMessage = function (props) {
    var dispatch = (0, react_redux_1.useDispatch)();
    var dispatchers = (0, dispatchers_1.mapDispatchers)(dispatch);
    var selectors = (0, selectors_1.mapSelectors)();
    return (React.createElement(GenericErrorMessage_1.default, { key: 'error', title: (0, translation_1.getLocalization)('generic/error') },
        React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: function () {
                return dispatchers.prevalidateFiles(props.currentFolder, __spreadArray([], selectors.cart.data.items.map(function (x) { return x.id; }), true).concat(selectors.checkingFiles.files.map(function (x) { return x.id; })), props.type);
            }, children: (0, translation_1.getLocalization)('generic/tryAgain') })));
};
exports.ValidationErrorMessage = ValidationErrorMessage;
